
export {Autocomplete,
Item} from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$autocomplete.js';
import __x__ from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$autocomplete.js';export default __x__;